import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    SettingType,
    Widget,
} from '@appblocks/codegeneration/types';
import BaseWidget, { sizes } from '@appblocks/codegeneration/Widgets/BaseWidget';

export default class TextWidget extends BaseWidget {
    constructor() {
        super();
        this.name = 'Text Input Widget';
        this.id = 'text_widget';
        this.minW = sizes[this.id].minW;
        this.minH = sizes[this.id].minH;

        const settings = this.getWidgetSettings(['VARIABLE', 'LABEL', 'MIN', 'MAX', 'BUTTON_LABEL']);

        this.settings = this.settings.concat(settings);
    }
}
